export default __webpack_public_path__ + "static/media/email.17bab4b1.svg";